import { useRef } from "react";

const useSound = (src: string) => {
  const audioRef = useRef<HTMLAudioElement>(new Audio(src));

  const playSound = () => {
    const sound = audioRef.current;
    sound.currentTime = 0;
    sound
      .play()
      .then(() => {})
      .catch((e) => {
        console.error("Failed to play sound:", e);
      });
  };

  return playSound;
};
export default useSound;
